import React, { createContext, useContext, useState, useCallback } from 'react';
import { useAuth } from './AuthContext';

const ToastContext = createContext();

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  
  const addToast = useCallback((message, type = 'success') => {
    const id = Date.now();
    const duration = type === 'undo' ? 4000 : 3000;
    setToasts(prev => [...prev, { id, message, type }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), duration);
  }, []);

  return (
    <ToastContext.Provider value={addToast}>
      {children}
      <div className="toast-container">
        {toasts.map(t => (
          <div key={t.id} className={`toast toast-${t.type} slide-up`}>
            {t.message}
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  const addToast = useContext(ToastContext);
  const auth = useAuth();
  
  return useCallback((message, type = 'success') => {
    // System toasts always show (settings saved, share link, errors)
    if (type === 'error' || type === 'system') {
      addToast(message, type === 'system' ? 'success' : type);
      return;
    }
    // Check notification preference
    if (auth?.userProfile?.showNotifications === false) return;
    addToast(message, type);
  }, [addToast, auth]);
}
